import React from 'react';
import './loading.css';

export const Loading = () => {
  return (

    <div className="loading-overlay">
      <div className="loading-div">
        <div className="spinner" />
      </div>
    </div>
  )
};
